export var LightningIconState;
(function (LightningIconState) {
    LightningIconState["ENABLED"] = "ENABLED";
    LightningIconState["PRIMARY"] = "PRIMARY";
})(LightningIconState || (LightningIconState = {}));
export const LightningIconColor = {
    [LightningIconState.ENABLED]: 'currentColor',
    [LightningIconState.PRIMARY]: 'var(--color-magenta50)',
};
